module.exports = __webpack_public_path__ + "6929c3d88ada68c8a33a6425f4795ff6.pdf";